export default __webpack_public_path__ + "static/media/(59).eca81d2c.jpg";